'use client';

import type { AnalyticsEventParamsType } from '@repo/analytics';
import { useEffect, useRef } from 'react';
import { trackEvent } from '@/lib/analytics';

interface ITrackViewOnMountProps {
  event: string;
  params?: AnalyticsEventParamsType;
}

export function TrackViewOnMount({ event, params }: ITrackViewOnMountProps): null {
  const sentRef = useRef(false);

  useEffect(() => {
    if (sentRef.current) {
      return;
    }
    sentRef.current = true;
    trackEvent(event, params);
  }, [event, params]);

  return null;
}
